
import {Content} from '../Templates'

export function Fatal({ }) {
    return (
        <Content>
            Fatal page
        </Content>
    );
}